import type { StringInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { ChangeEvent } from 'react'
import { InputFieldset } from '../inputFieldset'
import { Input } from '@/components/ui/input'

export default function StringInput(props: StringInputProps) {
  const { inputId, onChange, onFocus, onBlur, value, disabled, maxLength } =
    props

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const newValue = event.target.value

    if (maxLength !== undefined && newValue.length > maxLength) {
      onChange(newValue.slice(0, maxLength) || null)
      return
    }

    onChange(newValue || null)
  }

  const currentLength = value?.length ?? 0
  const characterCount =
    maxLength !== undefined
      ? `Maximum ${maxLength} characters — ${currentLength} used`
      : undefined

  const maxLengthReached =
    maxLength !== undefined && currentLength >= maxLength
      ? `Maximum ${maxLength} characters — ${maxLength} used`
      : undefined

  return (
    <InputFieldset
      {...props}
      errorMessage={maxLengthReached}
      helperText={characterCount}
    >
      <Input
        id={inputId}
        name={inputId}
        type='text'
        disabled={disabled}
        maxLength={maxLength}
        onBlur={onBlur}
        onChange={handleChange}
        onFocus={onFocus}
        value={value ?? undefined}
      />
    </InputFieldset>
  )
}
